import type { GeneratedExamPaper } from '../types/generated';
import type {
  Chapter,
  ExamType,
  QuestionVersion,
  Department,
  TemplatePart,
  DifficultyLevel,
} from '../types/wizard';
import { API_ROUTES } from '@app/common';
import { apiFetch } from './index';

export interface GenerateQuestionsParams {
  version: QuestionVersion;
  classLevel: number;
  department: Department;
  subject: string;
  subjectCode: string;
  paper: string;
  institutionName: string;
  chapters: Chapter[];
  examType: ExamType;
  numberOfQuestions: number;
  duration: number;
  totalMarks: number;
  templateParts: TemplatePart[];
  stimulusInstruction?: string;
  banglaStimlusInstruction?: string;
  difficulty: DifficultyLevel;
}

export const generateExamQuestions = (
  params: GenerateQuestionsParams
): Promise<GeneratedExamPaper> => {
  return apiFetch<GeneratedExamPaper>(API_ROUTES.GENERATE_QUESTIONS, {
    method: 'POST',
    body: JSON.stringify({
      ...params,
      chapters: params.chapters.map((ch) =>
        params.version === 'Bangla' ? ch.banglaName : ch.name
      ),
    }),
  });
};
